import React from 'react';
import Graph from '../Graph';
import Toggle from '../Toggle';

const Layout = ({ children, type, url, wcd, name, leftVal, leftText, rightText, rightVal, setValue, page }) => {

  const imageSectionStyleBlock = `
    .image-section:empty {
      background-image: url(${document.querySelector('#mth-calc-app').dataset.hero});
    }`

  const getPage = (pageSlug) => {
    switch (pageSlug) {
      case "results":
        return (
          <div className="graph-desktop">
            <Graph type={type} url={url} wcd={wcd} />
            <Toggle
              name={name}
              leftVal={leftVal}
              leftText={leftText}
              rightVal={rightVal}
              rightText={rightText}
              setValue={setValue}
            />
          </div>
        );
      case "returningResults":
        return (
          <div className="graph-desktop">
            <Graph type={type} url={url} wcd={wcd} />
            <Toggle
              name={name}
              leftVal={leftVal}
              leftText={leftText}
              rightVal={rightVal}
              rightText={rightText}
              setValue={setValue}
            />
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <>
      {/* eslint-disable react/no-danger */}
      <style dangerouslySetInnerHTML={{ __html: imageSectionStyleBlock }} />
      {/* eslint-enable react/no-danger */}
      <div className="mth-calc-layout">
        <div className="content-section">
          <div className="content-col">{children}</div>
        </div>
        <div className="image-section">
          {getPage(page)}

        </div>
      </div>
    </>
  );
};

export default Layout;
